import { useDispatch, useSelector } from 'react-redux';
import ResizablePanel from 'components/Panel/ResizablePanel';
import DsChatPanel from 'components/Panel/Chat/ChatPanel/DsChatPanel';
import { layout } from 'tokens';
import { RootReducer } from 'redux/reducers';
import { setDesignSystemChatPanelWidth } from 'redux/mode/actions';
import { selectDesignSystemChatPanelWidth } from 'redux/mode/reducers';

const DesignSystemLeftPanel = () => {
	const dispatch = useDispatch();
	const chatPanelWidth = useSelector((state: RootReducer) =>
		selectDesignSystemChatPanelWidth(state.mode)
	);

	const handleResize = (width: number) => {
		dispatch(setDesignSystemChatPanelWidth(width));
	};

	return (
		<ResizablePanel
			resizeOnSide="right"
			size={chatPanelWidth}
			onResize={handleResize}
			minSize={layout.panelMinWidth}
			maxSize={layout.panelMaxWidth}
		>
			<DsChatPanel />
		</ResizablePanel>
	);
};

export default DesignSystemLeftPanel;
